import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';
import { useParams } from "react-router-dom";

const GET_CONSULTANT_PAYSLIPS = gql`
  query ConsultantPayslips($consultantUuid: ID!, $sliceNumber: Int!) {
    consultantPayslips(payslipsRequest: { consultantUuid: $consultantUuid, sliceNumber: $sliceNumber }) {
      payslips {
        uuid
        payslipFileUuid
        year
        month
        currency
        grossSalary
        netSalary
        taxes
        bonus
        paymentDate
        createdAt
        employerContributions
        employeeContributions
        comment
        consultantProfileUuid
      }
      hasNext
    }
  }
`;

export const useConsultantPayslips = (sliceNumber) => {
    const { id: consultantUuid } = useParams();
    if (!consultantUuid) return;

    const { loading, error, data, refetch } = useQuery(GET_CONSULTANT_PAYSLIPS, {
        variables: { consultantUuid, sliceNumber },
        fetchPolicy: "network-only",
    });
    // console.log("hooks return are :", data, data?.consultantPayslips);

    return { loading, error, data: data?.consultantPayslips, refetch };
};
